import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useRoute } from 'vue-router/composables';

import BaseLogo from '@/components/BaseLogo.vue';
import Chevron from '@/components/widgets/Chevron.vue';
import LanguageSwitcher from '@/components/widgets/LanguageSwitcher.vue';
import MenuToggler from '@/components/widgets/MenuToggler.vue';
import store from '~store';


export default /*#__PURE__*/_defineComponent({
  __name: 'Navbar',
  props: {
  showChevrons: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {



const route = useRoute();
const { getters } = store;

const showNavBar = getters.getShowNavBar;
const loading = getters.getVariationLoading;
const links = getters.getNavbarLinks;
/*
     * Returns true if the route for redeem
     * is visible as the active / current route.
     */
const isActive = computed(() => {
  switch (route.name) {
    case 'redeem':
    case 'shops':
    case 'shopDetails':
    case 'amazonPayReturn':
      return true;

    default:
      return false;
  }
});

return { __sfc: true,route, getters, showNavBar, loading, links, isActive, BaseLogo, Chevron, LanguageSwitcher, MenuToggler }
}

})